<template>
  <div class="diseaseList">
    <!-- 筛选查询框 @change="selectGoodsByIdBtn"-->
    <el-form :inline="true">
      <el-button type="primary" size="small" v-waves @click="handleAdd">新增</el-button>
      <el-form-item label="一级分类: " style="margin:0 10px 10px" size="small">
        <el-select
          v-model="listQuery.productCategory_one"
          placeholder="请选择"
          clearable
          filterable
          @change="changeCategory(1,$event)"
        >
          <div v-for="item in categoryArr_one" :key="item.id">
            <el-option :label="item.categoryName" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类: " style="margin:0 10px 10px" size="small">
        <el-select
          v-model="listQuery.productCategory_two"
          placeholder="请选择"
          clearable
          filterable
          @change="changeCategory(2,$event)"
        >
          <div v-for="item in categoryArr_two" :key="item.id">
            <el-option :label="item.categoryName" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类: " style="margin:0 10px 10px" size="small">
        <el-select
          v-model="listQuery.productCategory_three"
          placeholder="请选择"
          clearable
          filterable
          @change="changeCategory(3,$event)"
        >
          <div v-for="item in categoryArr_three" :key="item.id">
            <el-option :label="item.categoryName" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称: " style="margin:0 10px 10px" size="small">
        <el-input v-model="listQuery.productName" placeholder="请输入商品名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="商品编码: " style="margin:0 10px 10px" size="small">
        <el-input v-model="listQuery.productCode" placeholder="请输入商品编码" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="getListData" size="small" v-waves>搜索</el-button>
      <!-- <el-button
        class="addBtn"
        type="primary"
        size="small"
        v-waves
        style="margin:0 10px 10px"
        :loading="downloadLoading"
        icon="el-icon-document"
        @click="handleDownload"
      >
        导出 Excel（数量/ {{ tableData.length
        }}条）
      </el-button>-->
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <!-- <template slot="store_id" slot-scope="{ row }">
          <StoreToString :store_id="row.store_id + ''" />
        </template>-->
        <template slot="img" slot-scope="{ row }">
          <img :src="row.img" alt style="width:100%" />
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-tag v-if="row.status === 4" effect="dark" type="danger" size="mini">审核中</el-tag>
          <span v-else>
            {{ arrayByIdToNameStr({
            ArrayData: statusDataList,
            id_key: "id",
            name_key: "status",
            ID: row.status,
            })}}
          </span>
        </template>

        <!-- 是否开启sku -->
        <template slot="isSku" slot-scope="{ row }">
          <el-switch
            :value="row.isSku == 1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="recommendChange(row, $event)"
          ></el-switch>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)" primary>详情(编辑)</el-button>
            <el-button size="mini" type="text" @click="ejectupdatImgs(row)" primary>商品图</el-button>
            <el-button size="mini" type="text" @click="handleSku(row)" primary v-if="row.isSku">商品规格</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>

      <!-- 产品提交表单 -->
      <el-dialog
        :title="inpitTypeName"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        width="600px"
      >
        <div style="height: 450px;overflow-y: auto;">
          <el-form :model="dialogForm" :label-width="formLabelWidth">
            <el-form-item label="一级分类: " required>
              <el-select
                v-model="dialogForm.productCategory_one"
                placeholder="请选择"
                @change="changeCategory_from(1,$event)"
                clearable
                filterable
              >
                <div v-for="item in categoryArr_one" :key="item.id">
                  <el-option :label="item.categoryName" :value="item.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="二级分类: " required>
              <el-select
                v-model="dialogForm.productCategory_two"
                placeholder="请选择"
                @change="changeCategory_from(2,$event)"
                clearable
                filterable
              >
                <div v-for="item in categoryArr_two_form" :key="item.id">
                  <el-option :label="item.categoryName" :value="item.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="三级分类: " required>
              <el-select
                v-model="dialogForm.productCategory_three"
                placeholder="请选择"
                @change="changeCategory_from(3,$event)"
                clearable
                filterable
              >
                <div v-for="item in categoryArr_three_form" :key="item.id">
                  <el-option :label="item.categoryName" :value="item.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="商品状态:">
              <el-select v-model="dialogForm.status" placeholder="不填写默认为上架">
                <div v-for="item in statusList" :key="item.id">
                  <el-option :label="item.status" :value="item.id"></el-option>
                </div>
              </el-select>
            </el-form-item>-->
            <el-form-item label="商品编码" required>
              <el-input v-model="dialogForm.productCode"></el-input>
            </el-form-item>
            <el-form-item label="商品名称" required>
              <el-input v-model="dialogForm.productName"></el-input>
            </el-form-item>
            <el-form-item label="商品库存">
              <el-input v-model="dialogForm.stockNum"></el-input>
            </el-form-item>
            <el-form-item label="商品描述" required>
              <el-input v-model="dialogForm.introduce" type="textarea"></el-input>
            </el-form-item>
            <!-- 市场参考价，未登录看到的价格 jdPrice /小程序未登录看到的价格  -->
            <el-form-item label="前台价" required>
              <el-input v-model="dialogForm.marketPrice" placeholder="用户未登录的价格"></el-input>
            </el-form-item>

            <!-- 登录后看到的价格 -->
            <el-form-item label="折扣价" required>
              <el-input v-model.number="dialogForm.price" type="number" placeholder="用户登录后的价格"></el-input>
            </el-form-item>

            <!-- 供应商给我们的结算价，成本价 京东的price 不对外展示 -->
            <el-form-item label="成本价" required>
              <el-input v-model.number="dialogForm.costPrice" placeholder="不对外展示" type="number"></el-input>
            </el-form-item>

            <el-form-item label="品牌">
              <el-input v-model="dialogForm.brand" placeholder="请输入"></el-input>
            </el-form-item>
            <!-- <el-form-item label="折扣价" required>
              <el-input v-model.number="dialogForm.price" type="number"></el-input>
            </el-form-item>-->
            <!-- <el-form-item label="商品视频链接">
              <el-input v-model="dialogForm.videoLink"></el-input>
            </el-form-item>-->
            <el-form-item label="排序大小">
              <el-input v-model="dialogForm.sort" placeholder="越大排名越前"></el-input>
            </el-form-item>

            <el-form-item label="商品封面图" width="100" required>
              <el-input v-model="dialogForm.coverImg" placeholder="上传后自动获取链接地址"></el-input>
              <el-upload
                style="margin-top: 0px;"
                :action="action"
                :multiple="false"
                :on-remove="handleRemove"
                :on-success="coverImgBtn"
                :file-list="fileList"
                list-type="picture"
                name="formData"
                :show-file-list="false"
                :before-upload="beforeUpload"
              >
                <el-button size="mini" type="primary" :loading="uploadLoadng">点击上传商品封面图(1张)</el-button>
              </el-upload>
              <div class="tip">只能上传jpg/png文件，500px X 500px</div>
              <div v-if="dialogForm.coverImg">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="dialogForm.coverImg"
                  :preview-src-list="[dialogForm.coverImg]"
                ></el-image>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- sku弹窗 -->
    <el-dialog title="商品规格" :visible.sync="skuVisible" :close-on-click-modal="false" width="650px">
      <!-- <div style="height: 450px;overflow-y: auto;"> -->
      <div class="sku_box">
        <h4>新增商品规格</h4>
        <el-form :model="skuForm" label-width="75px">
          <el-form-item label="规格名称">
            <el-input v-model="skuForm.sku" clearable></el-input>
          </el-form-item>
          <el-form-item label="价钱">
            <el-input v-model.number="skuForm.price" clearable type="number"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <el-button type="success" size="mini" @click="addSkuBtn">确定新增</el-button>
        </div>
      </div>

      <div class="sku_box" v-if="skuData.length > 0">
        <h4>商品规格展示</h4>
        <div class="skuList">
          <el-tag
            v-for="item in skuData"
            :key="item.id"
            @close="deleteSkuById(item.id)"
            closable
          >{{ item.sku }} (价格:{{ item.price }}元)</el-tag>
        </div>
      </div>
      <!-- </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="skuVisible = false">返回</el-button>
      </div>
    </el-dialog>

    <!-- 图片弹窗 -->
    <el-dialog title :visible.sync="dialogImgVisible" :close-on-click-modal="false" width="600px">
      <div class="imgUrlBox">
        <h2>商品主图</h2>
        <el-upload
          class="upload-demo"
          :action="action"
          :multiple="true"
          :on-remove="handleRemove"
          :on-success="headerImgBtn"
          :file-list="fileList"
          list-type="picture"
          name="formData"
          :show-file-list="false"
        >
          <el-button size="mini" type="primary">点击新增商品主图(最多5张)</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，500px X 500px, 上传后在尾部新增一条</div>
        </el-upload>
        <div class="imgUrlBoxShow">
          <div v-for="(item, index) in headerImg" :key="index" @click="handleEditImg(item)">
            <img :src="item.imgUrl" alt style="width:100%" />
          </div>
        </div>
      </div>

      <div class="detailsImgBox">
        <h2>商品详情图(已上传 {{ detailsImg.length }}张)</h2>
        <!--  :before-upload="beforeUpload" -->
        <el-upload
          class="upload-demo"
          :action="action"
          :multiple="true"
          :on-remove="handleRemove"
          :on-success="detailsImgBtn"
          :file-list="fileList"
          list-type="picture"
          name="formData"
          :show-file-list="false"
        >
          <el-button size="mini" type="primary">点击上传详情图</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，上传后在尾部新增一条</div>
        </el-upload>
        <div class="detailsImgBoxShow">
          <div v-for="(item, index) in detailsImg" :key="index" @click="handleEditImg(item)">
            <img :src="item.imgUrl" alt style="width:100%" />
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogImgVisible = false" plain size="mini">返回</el-button>
          <!-- <el-button type="primary" @click="updataImgBtn">确 定</el-button> -->
        </div>
      </div>
    </el-dialog>

    <!-- 图片操作弹窗 -->
    <el-dialog title="操作选中的图片" :visible.sync="imgEditVisible" :close-on-click-modal="false">
      <el-form :model="imgObj">
        <el-form-item label :label-width="formLabelWidth" width="100">
          <img :src="imgObj.imgUrl" alt style="width:200px; border: 1px dotted rgb(93, 93, 93);" />
        </el-form-item>

        <el-form-item label :label-width="formLabelWidth" width="100">
          <el-upload
            class="upload-demo"
            :action="action"
            :multiple="false"
            :on-remove="handleRemove"
            :on-success="updateImgBtn"
            :file-list="fileList"
            list-type="picture"
            name="formData"
          >
            <el-button size="small" type="primary">替换图片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，500px * 500px</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="排序大小" :label-width="formLabelWidth">
          <el-input v-model="imgObj.sort" auto-complete="off" placeholder="越大排名越靠后，默认为0"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="imgEditVisible = false">取 消</el-button>
        <el-button @click="handleDeleteImgItem">删 除</el-button>
        <el-button type="primary" @click="handleSaveImgItem">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectGoods,
  addGoods,
  updateGoods,
  updateSkuState,
  deleteGoodbyid,
  addSku,
  selectSku,
  deleteSku,
  selectImg,
  addImg,
  updateImg,
  deleteImg
} from "@/services/mall/goods.js";
import { queryList as selectCategory } from "@/services/mall/goodsCategory";
import ElTable from "@/components/elTable/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { IP } from "@/services/config.js";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
export default {
  components: {
    ElTable,
    StoreToString
  },
  created() {
    this.getListData();
    // 查询一级分类
    selectCategory({
      pageNumber: 1,
      pageSize: 1000,
      categoryLevel: 1
    }).then(res => {
      this.categoryArr_one = res.data.map(item => {
        return {
          ...item,
          name: item.categoryName
        };
      });
    });
  },

  data() {
    return {
      arrayByIdToNameStr,
      dialogForm: {
        coverImg: ""
      },
      dialogImgVisible: false, //产品图维护
      imgEditVisible: false,
      readVisible: false,
      imgObj: {},
      loading: false,
      listQuery: {
        productCategory_one: "",
        productCategory_two: "",
        productCategory_three: "",
        // type: 2,
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      status: 0,
      //状态列表
      statusDataList: [
        { id: 0, status: "上架" },
        { id: 1, status: "预售" },
        { id: 2, status: "补货" },
        { id: 3, status: "下架" },
        { id: 4, status: "审核中" },
        { id: 5, status: "已删除" }
      ],
      statusList: [
        { id: 0, status: "上架" },
        { id: 1, status: "预售" },
        { id: 2, status: "补货" },
        { id: 3, status: "下架" }
      ],
      goodsTitle: "",
      tableData: [],
      categoryId: "",
      productName: "",

      // 搜索栏一级二级三级分类
      categoryArr_one: [],
      categoryArr_two: [],
      categoryArr_three: [],

      // 弹窗栏
      categoryArr_two_form: [],
      categoryArr_three_form: [],

      dialogFormVisible: false,
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      /* sku相关参数 */
      skuData: [], //sku数组
      skuActive: "",
      skuForm: {
        //新增sku
        productId: "",
        price: "",
        sku: ""
      },
      skuVisible: false,
      uploadLoadng: false,
      downloadLoading: false,

      //修改后的价格比对
      editForm: {}
    };
  },

  computed: {
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },

  methods: {
    /* 切换分类 */
    changeCategory(index, value) {
      if (index == 1) {
        this.listQuery.productCategory_two = "";
        this.listQuery.productCategory_three = "";
        selectCategory({
          pageNumber: 1,
          pageSize: 1000,
          categoryLevel: 2,
          parentID: value
        }).then(res => {
          this.categoryArr_two = res.data.map(item => {
            return {
              ...item,
              name: item.categoryName
            };
          });
        });
      }
      if (index == 2) {
        this.listQuery.productCategory_three = "";
        selectCategory({
          pageNumber: 1,
          pageSize: 1000,
          categoryLevel: 3,
          parentID: value
        }).then(res => {
          this.categoryArr_three = res.data.map(item => {
            return {
              ...item,
              name: item.categoryName
            };
          });
        });
      }
    },

    /* 切换分类-弹窗 */
    changeCategory_from(index, value) {
      if (index == 1) {
        this.dialogForm.productCategory_two = "";
        this.dialogForm.productCategory_three = "";
        selectCategory({
          pageNumber: 1,
          pageSize: 1000,
          categoryLevel: 2,
          parentID: value
        }).then(res => {
          this.categoryArr_two_form = res.data.map(item => {
            return {
              ...item,
              name: item.categoryName
            };
          });
        });
      }
      if (index == 2) {
        this.dialogForm.productCategory_three = "";
        selectCategory({
          pageNumber: 1,
          pageSize: 1000,
          categoryLevel: 3,
          parentID: value
        }).then(res => {
          this.categoryArr_three_form = res.data.map(item => {
            return {
              ...item,
              name: item.categoryName
            };
          });
        });
      }
    },

    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      //供应商只能查询自己上传的商品
      listQuery.create_user = this.userInfo.username;
      this.loading = true;
      const { data, code, count } = await selectGoods({
        ...listQuery
      });
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /* 通过筛选查商品 */
    selectGoodsByIdBtn() {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 显示商品sku设置 */
    recommendChange(row, val) {
      this.$confirm(
        `是否确认${val == "1" ? "打开" : "隐藏"}商品规格设置？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        if (val === true) {
          row.isSku = "1";
        } else {
          row.isSku = "0";
        }
        updateSkuState({ id: row.id, isSku: row.isSku }).then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "操作成功",
              offset: 100
            });
            this.updateStatus(row.id);
            this.getListData();
          } else {
            this.$message({
              type: "error",
              message: "操作失败",
              offset: 100
            });
            if (val == "0") {
              row.isSku = 1;
            } else {
              row.isSku = 0;
            }
          }
        });
      });
    },

    /* sku弹窗 */
    handleSku(row) {
      this.skuVisible = true;
      this.skuActive = "";
      this.skuForm.productId = row.id;
      this.selectSkuById(row.id); //查询sku
    },
    /**
     * 查询sku
     * @param {productId} 商品id
     */
    selectSkuById(productId) {
      selectSku({ productId }).then(res => {
        this.skuData = res.data;
      });
    },

    /* 修改状态 */
    updateStatus(id) {
      updateGoods({
        id,
        status: 4
      }).then(resp => {
        if (resp.code == 200) {
          this.getListData();
        }
      });
    },
    /* 新增sku */
    addSkuBtn() {
      if (
        this.skuForm.price === "" ||
        this.skuForm.sku === "" ||
        this.skuForm.minNum === "" ||
        this.skuForm.maxNum === ""
      ) {
        return this.$message.error("选项不能为空");
      }
      addSku(this.skuForm).then(() => {
        this.selectSkuById(this.skuForm.productId);
        this.$message.success("新增成功");
        this.updateStatus(this.skuForm.productId);
      });
    },

    deleteSkuById(id) {
      deleteSku(id).then(res => {
        if (res.code === 200) {
          this.selectSkuById(this.skuForm.productId);
          this.updateStatus(this.skuForm.productId);
        }
      });
    },

    skuActiveBtn(id) {
      console.log(id);
      this.skuActive = id;
    },

    /* 文件上传 */
    beforeUpload(e) {
      console.log("开始上传", e);
      this.uploadLoadng = true;
    },
    coverImgBtn(e) {
      this.dialogForm.coverImg = e.data;
      this.uploadLoadng = false;
      // console.log("上传成功", this.dialogForm.coverImg);
    },

    handleRemove(e, fileList) {
      console.log("移除---------------", e, fileList);
    },

    /* 新增 */
    handleAdd() {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增商品";
      this.headerImg = [];
      this.detailsImg = [];
      this.fileList = [];
      this.dialogForm = {
        productCategory_one: "",
        productCategory_two: "",
        productCategory_three: ""
      };
      this.categoryArr_two_form = [];
      this.categoryArr_three_form = [];
    },

    /* 编辑商品 */
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改商品详情";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.editForm = JSON.parse(JSON.stringify(row));
      //编辑初始化分类
      selectCategory({
        pageNumber: 1,
        pageSize: 1000,
        categoryLevel: 2,
        parentID: this.dialogForm.productCategory_one
      }).then(res => {
        this.categoryArr_two_form = res.data.map(item => {
          return {
            ...item,
            name: item.categoryName
          };
        });
      });
      selectCategory({
        pageNumber: 1,
        pageSize: 1000,
        categoryLevel: 3,
        parentID: this.dialogForm.productCategory_two
      }).then(res => {
        this.categoryArr_three_form = res.data.map(item => {
          return {
            ...item,
            name: item.categoryName
          };
        });
      });

      this.headerImg = [];
      this.detailsImg = [];
      this.fileList = [];
    },
    handlePictureCardPreview(file) {
      this.readVisible = true;
    },
    /* 商品图片管理 */
    ejectupdatImgs(row) {
      this.dialogImgVisible = true;
      // this.inpitTypeName = "商品图片维护";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      //查询
      this.handleSeletImg();
      this.handleSeletDeatilImg();
    },

    /* 根据商品id查询主图 */
    handleSeletImg() {
      selectImg({ productId: this.form.id, imgType: 1 }).then(res => {
        this.headerImg = res.data;
      });
    },

    /* 根据商品id查询详情图 */
    handleSeletDeatilImg() {
      selectImg({ productId: this.form.id, imgType: 2 }).then(res => {
        console.log("详情图", res);
        this.detailsImg = res.data;
      });
    },

    /* 新增商品主图 */
    headerImgBtn(e) {
      console.log("新增商品主图==========", e);
      addImg({
        productId: this.form.id,
        imgUrl: e.data,
        imgType: 1
      }).then(res => {
        // this.fileList = [];
        this.handleSeletImg();
        this.updateStatus(this.form.id);
      });
    },

    /* 新增详情图 */
    detailsImgBtn(e) {
      console.log("detailsImgBtn=====================", e);
      addImg({
        productId: this.form.id,
        imgUrl: e.data,
        imgType: 2
      }).then(res => {
        // this.fileList = [];
        this.handleSeletDeatilImg();
        this.updateStatus(this.form.id);
      });
    },

    /* 编辑图片弹窗 */
    handleEditImg(row) {
      this.imgEditVisible = true;
      this.imgObj = JSON.parse(JSON.stringify(row));
    },

    /* 编辑图片 */
    updateImgBtn(e) {
      this.fileList = [];
      this.imgObj.imgUrl = e.data;
    },

    /* 保存编辑的图片 */
    handleSaveImgItem() {
      console.log(this.imgObj);
      updateImg(this.imgObj).then(resp => {
        console.log(resp);
        this.$message({
          type: "success",
          message: "修改成功!"
        });
        this.imgEditVisible = false;
        //查询
        this.handleSeletImg();
        this.handleSeletDeatilImg();
      });
    },

    /* 删除图片 */
    handleDeleteImgItem() {
      console.log(this.imgObj.id);
      this.$confirm("此操作将永久删除该图片吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteImg({ id: this.imgObj.id }).then(resp => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.imgEditVisible = false;
            //查询
            this.handleSeletImg();
            this.handleSeletDeatilImg();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /* 保存 */
    save() {
      let formData = JSON.parse(JSON.stringify(this.dialogForm));
      formData.type = 2; //微商城
      formData.create_user = this.userInfo.username;
      if (
        !formData.productCategory_one ||
        !formData.productCategory_two ||
        !formData.productCategory_three ||
        !formData.marketPrice ||
        !formData.price ||
        !formData.productName ||
        !formData.introduce ||
        !formData.coverImg
      ) {
        this.$message.error("请填写必填字段，且价格字段不能为0");
        return;
      }
      if (this.inpitTypeName == "新增商品") {
        formData.status = 4; //审核中
        addGoods(formData).then(resp => {
          console.log(resp);
          if (resp.code == 200) {
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
            this.getListData();
          } else {
            this.$message.error("操作失败");
          }
        });
        return;
      }
      if (this.inpitTypeName == "修改商品详情") {
        //比对3个价格
        if (formData.marketPrice > this.editForm.marketPrice) {
          this.$message.error("前台价不能调高");
          return;
        }
        if (formData.price > this.editForm.price) {
          this.$message.error("折扣价不能调高");
          return;
        }

        if (formData.costPrice > this.editForm.costPrice) {
          this.$message.error("成本价不能调高");
          return;
        }
        //修改
        updateGoods(formData).then(resp => {
          if (resp.code == 200) {
            this.$message.success("修改成功");
            this.dialogFormVisible = false;
            this.getListData();
          } else {
            this.$message.error("修改失败");
          }
        });
      }
    },
    handleDelete(row) {
      this.$confirm(
        `此操作将永久删除'${row.productName}'商品吗, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        updateGoods({ id: row.id, status: 5 }).then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          }
        });
        // deleteGoodbyid({ id: row.id }).then(res => {
        //   if (res.code === 200) {
        //     this.$message({
        //       type: "success",
        //       message: "删除成功!"
        //     });
        //     this.getListData();
        //   }
        // });
      });
    },

    /* 导出数据 */
    handleDownload() {
      this.downloadLoading = true;
      import("@/utils/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "ID",
          "商品编码",
          "产品名",
          "商品封面图",
          "商品一级分类ID",
          "商品二级分类ID",
          "商品三级分类ID",
          "价格",
          "市场参考价",
          "品牌",
          "状态",
          "创建时间"
        ];
        const filterVal = [
          "id",
          "productCode",
          "productName",
          "coverImg",
          "productCategory_one",
          "productCategory_two",
          "productCategory_three",
          "price",
          "marketPrice",
          "brand",
          "status",
          "createTime"
        ];
        const list = this.tableData.map(item => {
          return {
            ...item,
            status:
              item.status === 0
                ? "显示"
                : item.status === 1
                ? "预售 "
                : item.status === 2
                ? "补货 "
                : "下架 " //0显示 1预售 2补货 3下架
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "商品数据下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  }
};
</script>

<style scoped>
.diseaseList {
  width: 100%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.goodsTitle:hover {
  cursor: pointer;
}

.upload-demo {
  margin: 5px 0;
}

/* sku */
.sku_box {
  border: 1px solid rgb(182, 182, 182);
  padding: 20px 10px;
  border-radius: 20px;
  margin: 15px 0 0;
}

.sku_box > h4 {
  margin: 0 0 10px;
}

.skuList {
  /* border: 2px dotted rgb(189, 189, 189); */
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0 0;
}

.skuList > span {
  margin: 3px 10px;
}

/* 详情页 */
h2 {
  font-size: 16px;
}

.imgUrlBox,
.detailsImgBox {
  width: 100%;
}

.imgUrlBox {
  margin-bottom: 30px;
}

.imgUrlBoxShow {
  display: flex;
}

.imgUrlBoxShow > div {
  margin: 0px 10px 0 0;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border: 1px dotted rgb(93, 93, 93);
}

.imgUrlBoxShow > div:hover {
  cursor: pointer;
}

.detailsImgBoxShow {
  width: 550px;
  height: 400px;
  overflow-y: auto;
  border: 1px solid rgb(204, 204, 204);
  /* margin: 0 auto; */
}

.detailsImgBoxShow > div {
  width: 85%;
  border: 1px dotted rgb(93, 93, 93);
  margin: 0 auto;
}

.detailsImgBoxShow > div:hover {
  cursor: pointer;
}

.detailsImgBoxShow > div img {
  width: 100%;
}

/* 按钮 */
.dialog-footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.tip {
  margin-top: -10px;
  font-size: 14px;
}
</style>
